import React from "react";
import { graphql } from "react-apollo";
import { dateComparator } from "../utils/sorters";
import JobServicesQuery from "../queries/JobServices";
import ServiceCard from "./ServiceCard";
import CenteredLoader from "./CenteredLoader";

class ServicesSidebar extends React.Component {
  componentDidMount() {
    if (this.props.data.refetch) this.props.data.refetch();
  }

  render() {
    const { match, data: { loading, error, services } } = this.props;

    if (loading && !services) return <CenteredLoader />;
    if (error) return "Error";

    return services
      .slice()
      .sort(dateComparator("updatedAt", "desc"))
      .map(service => (
        <ServiceCard key={service.id} service={service} baseUrl={match.url} />
      ));
  }
}

export default graphql(JobServicesQuery, {
  options: ({ match: { params: { jobId } } }) => ({
    variables: { jobId },
    pollInterval: 1000 * 30
  })
})(ServicesSidebar);



// WEBPACK FOOTER //
// ./src/components/ServicesSidebar.js